"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Full3DRotationSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const Feature_1 = require("../Feature");
function Full3DRotationSwitch() {
    return ((0, jsx_runtime_1.jsx)(Feature_1.Feature, { type: bridge_schema_1.PreferenceBoolOption.Full3dRotation, "data-e2e": 'Full3DRotationSwitch_Feature', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.full3dRotation.description) }));
}
exports.Full3DRotationSwitch = Full3DRotationSwitch;
